
import Vue from 'vue'
import { DatePicker, Dropdown, Btn } from 'uiv'
import { ensureValueIsDate } from '@/services/DateHelpers'

export default Vue.extend({
   props: {
      value: [Date, String],
      start: Date,
      end: Date,
      view: String,
   },
   data() {
      return {
         initialDate: null as Date | null,
         date: null as Date | null,
      }
   },
   mounted() {
      if (this.value !== null) {
         this.initialDate = ensureValueIsDate(this.value)
         this.date = ensureValueIsDate(this.value)
      }
   },
   watch: {
      value(newValue: Date) {
         if (newValue !== this.date) {
            this.initialDate = ensureValueIsDate(this.value)
            this.date = ensureValueIsDate(this.value)
         }
      },
      date() {
         if (this.date !== this.initialDate) {
            this.$emit('input', this.date)
            this.$emit('change', this.date)
         }
      },
   },
   components: {
      DatePicker,
      Dropdown,
      Btn,
   },
})
